import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { SUPPORT } from "../lib/api";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-ink/10 bg-white px-6 lg:px-10 py-20"
    >
      <div className="mx-auto max-w-7xl grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Link
            to="/"
            className="font-display font-black text-4xl tracking-tighter text-ink"
          >
            save<span className="text-brand text-glow-brand">u</span>
          </Link>
          <p className="mt-6 max-w-sm text-ink-soft leading-relaxed">
            The campus companion that shows you where the night's alive, drops
            real deals, and turns going out into a game worth winning.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="font-display uppercase text-xs tracking-[0.3em] text-brand-dark mb-6">
            Pages
          </p>
          <ul className="space-y-4">
            {[
              { to: "/", label: "Home" },
              { to: "/faq", label: "FAQ" },
              { to: "/privacy", label: "Privacy Policy" },
              { to: "/support", label: "Support & Contact" },
            ].map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.split(" ")[0].toLowerCase()}`}
                  className="text-ink-soft hover:text-brand transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-display uppercase text-xs tracking-[0.3em] text-brand-dark mb-6">
            Reach us
          </p>
          <a
            data-testid="footer-email"
            href={`mailto:${SUPPORT.email}`}
            className="flex items-center gap-3 text-ink-soft hover:text-brand transition-colors mb-4"
          >
            <Mail size={18} /> {SUPPORT.email}
          </a>
          <a
            data-testid="footer-phone"
            href={`tel:${SUPPORT.phone}`}
            className="flex items-center gap-3 text-ink-soft hover:text-brand transition-colors"
          >
            <Phone size={18} /> {SUPPORT.phoneDisplay}
          </a>
        </div>
      </div>

      <div className="mx-auto max-w-7xl mt-16 pt-8 border-t border-ink/10 flex flex-col md:flex-row justify-between gap-4 text-ink-faint text-sm">
        <p>© {new Date().getFullYear()} saveu. All rights reserved.</p>
        <p className="font-body">Made for campus nights.</p>
      </div>
    </footer>
  );
};
